<template lang="pug" src="./hero-pages-image.pug"></template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      loaded: false
    }
  },
  async mounted () {
    setTimeout(e => { this.loaded = true }, 400)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/hero/hero-pages-image/hero-pages-image.vue